import { option } from 'fp-ts';
import { identity } from 'fp-ts/function';
import { Prism } from 'monocle-ts';
/**
 * Build a record of prisms to match the elements of a primitive union.
 *
 * @example
 * type U = 'foo' | 'bar';
 * const prisms = prism.fromKeys<U>();
 * prisms.foo.getOption('foo') // some('foo')
 * prisms.foo.getOption('bar') // none
 */
export const fromKeys = () => new Proxy({}, {
    get(prisms, prop) {
        const key = prop;
        if (!(key in prisms)) {
            prisms[key] = new Prism(option.fromPredicate((u) => u === key), identity);
        }
        return prisms[key];
    },
});
/**
 * Build a record of prisms to match the elements of a discriminated union type.
 */
export const fromTag = (p) => new Proxy({}, {
    get(prisms, prop) {
        const tag = prop;
        if (!(tag in prisms)) {
            prisms[tag] = new Prism(option.fromPredicate((u) => u[p] === tag), identity);
        }
        return prisms[tag];
    },
});
//# sourceMappingURL=prism.js.map